import buildUrl from 'modules/core/lib/buildUrl'

import {
  StrategyItem,
  StrategySelectorEmployee,
  StrategySelectorTeam,
  StrategySelectorTreeRoles,
} from './interfaces'
import { getStrategyOptions } from './strategyUtils'

export interface StrategyDisplayInfo {
  label: string
  avatarSrc?: string
  avatarFirstName?: string
  avatarLastName?: string
  isDeactivated?: boolean
}

export const getStrategyDisplayInfo = (data: {
  strategy: StrategyItem
  employees: Array<StrategySelectorEmployee>
  teams: Array<StrategySelectorTeam>
  roles: Array<StrategySelectorTreeRoles>
}): StrategyDisplayInfo => {
  const { strategy, employees, teams, roles } = data

  const strategyLabel = getStrategyOptions(strategy.type).label || strategy.type

  if (strategy.type === 'manual_selection' && strategy.employeeId) {
    const employee = employees.find((emp) => emp.id === strategy.employeeId)
    const fullName = employee?.fullName ?? ''
    const nameParts = fullName.split(' ')
    const avatarUrl = employee?.avatar
    return {
      label: fullName,
      avatarSrc: avatarUrl ? buildUrl(avatarUrl) : undefined,
      avatarFirstName: nameParts[0] ?? '',
      avatarLastName: nameParts.slice(1).join(' '),
      isDeactivated: employee?.terminated ?? false,
    }
  }

  if (strategy.teamId) {
    const team = teams.find((t) => t.id === strategy.teamId)
    const teamName = team?.name || ''

    let label = ''
    if (strategy.type === 'team_leads') {
      label = `Team leads of ${teamName}`
    } else if (strategy.type === 'anyone_in_team') {
      label = `Anyone in ${teamName}`
    } else {
      label = `${strategyLabel} - ${teamName}`
    }

    return {
      label,
      avatarFirstName: teamName,
      avatarSrc: undefined,
    }
  }

  if (strategy.roleId) {
    let roleName = ''

    if (strategy.roleId.startsWith('jobcatalog_treerole-')) {
      roleName = roles.find((r) => r.uuid === strategy.roleId)?.name || ''
    } else {
      const role = roles.find((r) => r.id === strategy.roleId)
      roleName = role?.name || ''
    }

    return {
      label: `${strategyLabel} - ${roleName}`,
      avatarFirstName: roleName,
      avatarSrc: undefined,
    }
  }

  return {
    label: strategyLabel,
    avatarFirstName: strategyLabel,
    avatarSrc: undefined,
  }
}
